import { Button, Modal, Form, Input, Select } from "antd"
import React, { useState } from "react"

const { Option } = Select

const AddListinoModal = ({
  isVisible = true,
  onClose,
  form,
  createListino,
  listinoList,
}) => {
  const { getFieldDecorator, validateFields } = form
  const [loading, setLoading] = useState(false)

  const handleSubmit = () => {
    validateFields((err, values) => {
      if (!err) {
        createListino(
          values.name,
          values.description,
          values.listinoId,
          setLoading,
          onClose
        )
      }
    })
  }

  return (
    <Modal
      className="add-service-modal"
      title="Crea Nuovo Listino"
      visible={isVisible}
      onCancel={onClose}
      width={500}
      footer={
        <Button type="primary" block onClick={handleSubmit} loading={loading}>
          Crea Listino
        </Button>
      }
    >
      <Form layout="vertical" className="add-service-form">
        <Form.Item label="Seleziona un Listino">
          {getFieldDecorator("listinoId", {
            initialValue: listinoList?.length ? listinoList[0].id : undefined, // Set first item as default
            rules: [{ required: true, message: "Per favore seleziona un listino!" }],
          })(
            <Select placeholder="Seleziona un listino">
              {listinoList?.map((listino) => (
                <Option key={listino.id} value={listino.id}>
                  {listino.name}
                </Option>
              ))}
            </Select>
          )}
        </Form.Item>

        <Form.Item label="Nome Listino">
          {getFieldDecorator("name", {
            rules: [
              {
                required: true,
                message: "Per favore inserisci il nome del listino!",
              },
            ],
          })(<Input placeholder="Nome del Listino" />)}
        </Form.Item>

        <Form.Item label="Note">
          {getFieldDecorator("description")(
            <Input.TextArea
              className="input-textarea"
              placeholder="Inserisci descrizione o note"
              rows={5}
            />
          )}
        </Form.Item>
      </Form>
    </Modal>
  )
}

const AddListinoModalForm = Form.create()(AddListinoModal)
export default AddListinoModalForm
